import { EActions, EStorageType } from 'reactApp/modules/storage/storage.types';
import { isAiOrganizeSearchBttnInToolbar } from 'reactApp/ui/FakedoorNeuroOrganizePromo/utils';
import { toolbarItems } from 'reactApp/ui/Toolbar/Toolbar.data.new';

export const useAiOrganizeFakedoorActions = ({ storage }: { storage: EStorageType }) => {
    if (storage !== EStorageType.home && storage !== EStorageType.attaches) {
        return [];
    }

    return isAiOrganizeSearchBttnInToolbar() ? [toolbarItems[EActions.searchAiOrganizeFakedoor]] : [];
};
